import { render, staticRenderFns } from "./more-help.vue?vue&type=template&id=ce1dd316"
import script from "./more-help.vue?vue&type=script&lang=ts"
export * from "./more-help.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports